module.exports = __webpack_public_path__ + "img/watch-your-step.23f9c8f3.png";